// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../config/styles';

const styles = ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 0',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  text: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
});

export default styles;
